<template>
  <div style="min-height: 500px;">
    <FuncionalidadeHeader
      v-if="funcData.parametros.textos.tituloNavegacao"
      :titulo="funcData.parametros.textos.tituloNavegacao"
    />
    <div class="trocar-senha">
      <p
        v-if="funcData.parametros.textos.cabecalho"
        class="recuperar-cabecalho"
      >
        {{ funcData.parametros.textos.cabecalho }}
      </p>

      <div
        id="form-render-trocar-senha"
      />

      <p
        v-if="funcData.parametros.textos.rodape"
        class="recuperar-rodapé"
      >
        {{ funcData.parametros.textos.rodape }}
      </p>
      <AlertaErro
        v-model="erro.show"
        :title="erro.titulo"
        :description="erro.descricao"
      />
      <ButtonDefault
        :title="funcData.parametros.textos.botaoEnviar"
        @click="enviar"
      />
      <ButtonDefault
        :title="'Central de ajuda'"
        v-if="config.configuracaoAcesso.centralDeAjuda.ativo"
        :secundario="true"
      />
    </div>
  </div>
</template>

<script>
import AlertaErro from '@/components/AlertaError/AlertaErro'
import { mapActions, mapGetters, mapState } from 'vuex'
import { renderForm } from '@mobilesaude/form-builder-sdk'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ButtonDefault from '@/components/buttons/ButtonDefault'

export default {
  name: 'Func138TrocarSenha',
  components: { FuncionalidadeHeader, AlertaErro, ButtonDefault },
  data () {
    return {
      form: {},
      erro: {
        show: false,
        titulo: 'Erro no preenchimento:',
        descricao: ''
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState('SetupApp', ['config', 'apiAcesso', 'frameId']),
    ...mapGetters('SetupApp', ['estilo']),
    funcData () {
      return this.config.configuracaoAcesso.trocarSenha
    },
    formBuilderColors () {
      const colors = this.estilo.formBuilder

      if (!colors) {
        return {}
      }

      return {
        primary: colors.corPrincipalFormBuilder,
        errors: colors.corErroFormBuilder,
        alert: colors.corAlertaFormBuilder
      }
    },
    buttonStyle () {
      return {
        'background-color': this.estilo.aplicacao.corPrimariaAplicacao
      }
    },
    styleSecundario () {
      return {
        'background-color': this.estilo.aplicacao.corSecundariaAplicacao
      }
    }
  },
  methods: {
    ...mapActions('Login', ['setLogin']),
    async init () {
      this.initFormRedefinirSenha()
    },
    initFormRedefinirSenha () {
      this.initForm(
        this.funcData.parametros.formularios.formTrocarSenha,
        'form-render-trocar-senha'
      )
    },
    initForm (formId, id) {
      let params = {
        identifier: id,
        clientKey: this.config.aplicacao.clientKey,
        'idForm': formId,
        'colors': { ...this.formBuilderColors }
      }
      this.form = renderForm(params)
    },
    showError () {
      this.erro.descricao = ``
      this.erro.show = true
    },
    async enviar () {
      this.erro.show = false

      const formData = await this.form.validateAll()
      if (!formData || !formData.status) {
        return
      }

      const payload = formData.data

      const response = await this.apiAcesso.trocarSenha.trocarSenha({
        payload,
        loading: true,
        handlerErrorIgnore: [401, 404, 400]
      })

      if (!response) {
        this.erro.descricao = `<ul><li>Não foi possível trocar a senha. Tente novamente mais tarde.</li></ul>`
        this.erro.show = true
      } else if (response.code !== 401) {
        this.erro.descricao = `<ul><li>${response.message}</li></ul>`
        this.erro.show = true
      }
    },
    voltar () {
      this.$emit('voltar')
    }
  }
}
</script>

<style scoped>
.trocar-senha {
  margin: 20px;
  max-width: 610px;
}

.recuperar-cabecalho {
  letter-spacing: 0;
  color: #333333;
  margin-bottom: 15px;
}

.recuperar-rodapé {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #333333;
  margin-bottom: 15px;
}

</style>
